import { V1, V3, V4 } from 'Util/fetcher';

// Config

export const tradingTimeUrl = `${V1}stock/data/trading-day/time/`;

// Profile
//

export const stockSREUrl = `${V1}stock/customer-legal-info/`;
export const stockTradelimitUrl = `${V1}stock/tradelimit/`;
export const stockBannerInfo = `${V1}users/cta/?banner_type=EXPLORE`;

// Stock Detail
//

// https://ajaib.readme.io/reference/about-1
export const stockDetailUrl = (code) => `${V1}stock/detail/${code}/about/`;
// https://ajaib.readme.io/reference/latest-price
export const stockPriceUrl = (code) => `${V1}stock/detail/${code}/price/`;
// https://ajaib.readme.io/reference/discovery-list
export const stockDiscoveryListUrl = `${V1}stock/discovery/group/member/`;
export const stockListByKeywordUrl = `${V1}stock/`;

// Portfolio
//

// https://ajaib.readme.io/reference/portofolio
export const stockPortfolioListUrl = `${V3}stock/portfolio/`;
// https://ajaib.readme.io/reference/portofolio-detail
export const stockPortfolioDetailUrl = `${V3}stock/portfoliodetail/`;
// https://ajaib.readme.io/reference/retrieve-portfolio
export const stockPortfolioBonusUrl = `${V1}stock/bonus/portfolio/`;
// https://ajaib.readme.io/reference/order-list-with-filter-feature
export const stockOrderOpenUrl = `${V4}stock-trading/public/order/REG/list`;
// https://ajaib.readme.io/reference/tradelist-with-filter
export const stockOrderHistoryUrl = `${V3}stock-trading/public/order/REG/history/list`;
// https://ajaib.readme.io/reference/list
export const stockAutoOrderListUrl = `${V1}stock/auto-trading/`;

// Trading
//

/**
 * - Buy:       https://ajaib.readme.io/reference/buy-stock
 * - Sell:      https://ajaib.readme.io/reference/sell-stock
 * - Amend:     https://ajaib.readme.io/reference/amend-stock
 * - Withdraw:  https://ajaib.readme.io/reference/withdraw-order
 *
 * @param {'buy'|'sell'|'amend'|'withdraw'|'bonus/sell'} type
 */
export const stockOrderUrl = (type) => `${V1}stock/${type}/`;

/**
 * - Sell Bonus:  ??
 * - Amend Bonus: ??
 *
 * @param {'sell'|'amend'} type
 */
export const stockBonusOrderUrl = (type) => `${V1}stock/bonus/${type}/`;

/**
 * - Create Auto Trading:  https://ajaib.readme.io/reference/post-1
 *
 * @param {'REG'|'MARGIN'} account
 */
export const stockAutoOrderUrl = (account) => `${V1}stock/auto-trading/?account_type=${account}`;

/**
 * - Amend Auto Trading:      https://ajaib.readme.io/reference/put
 * - Deactivate Auto Trading: https://ajaib.readme.io/reference/pause
 * - Reactivate Auto Trading: https://ajaib.readme.io/reference/resume
 * - Cancel Auto Trading:     https://ajaib.readme.io/reference/cancel
 * @param {''|'pause/'|'resume/'|'cancel/'} action
 * @param {string} order_id
 */
export const stockAutoOrderByIdUrl = (action, order_id) =>
  `${V1}stock/auto-trading/${order_id}/${action}`;
